import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import projectConfig, { PROJECT } from '~/projects/config';
import { GB_FEATURE_KEYS } from '~/services/abTests/features';

export const useIsBillingHistoryEnabled = (): boolean => {
  const isBillingFlagEnabled = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.BILLING_HISTORY,
  );

  // Sidekicker has no GrowthBook integration yet, so billing history is
  // enabled for all of its users regardless of the feature flag.
  return projectConfig.project === PROJECT.SIDEKICKER || isBillingFlagEnabled;
};
